import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';

import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List';
import { MenuList, MenuItem } from 'material-ui/Menu';

import Reboot from 'material-ui/Reboot';
import 'typeface-roboto';
import Table, {
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
} from 'material-ui/Table';

import TextField from 'material-ui/TextField';
import {ajaxPost} from '../ajax';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import { CircularProgress } from 'material-ui/Progress';
import green from 'material-ui/colors/green';
import Portal from 'material-ui/Portal'
import Paper from 'material-ui/Paper';
import SaveIcon from 'material-ui-icons/Save';
import Tooltip from 'material-ui/Tooltip';
import IconButton from 'material-ui/IconButton/IconButton';

import Select from 'react-select';
import 'react-select/dist/react-select.css';
import {
  FormLabel,
  FormControl,
  FormGroup,
  FormControlLabel,
  FormHelperText,
} from 'material-ui/Form';

var {fnSearchEmployee} = require('./utils');

var moment = require('moment');

const styles = theme => ({
  title:
  {
    //color:"#2574bb",
    flex:1,
marginTop:15,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: "-1",
    width: 150,
},
container: {
  display: 'flex',
  //flexWrap: 'wrap',
},
button:
{
  height:30,
  margin:5,
},
root: {
  width: '100%',
  marginTop: theme.spacing.unit * 3,
  overflowX: 'auto',
},
table: {
  minWidth: 700,
  marginTop:20,
},
main:
{
  margin:10
},
fabProgress: {
  color: green[500],
  position: 'absolute',
  top: '50%',
  left: '50%',
  marginTop: -15,
  marginLeft: -15,
    },
    wrapper: {
      // margin: theme.spacing.unit,
      // position: 'relative',
      // display:'inline-flex',
    },
    select:
    {
        width:250,
        margin:5,
    },
    selectLabel:
    {
      fontSize:"10.5pt",
      marginTop:20,
      paddingLeft:20,
    },
    tableContent:{
        "font-weight":"500",
    },

});

class AuditTrail extends Component {
  dt = moment().format('YYYY-MM-DD');
  state = 
  {
    StartDate:this.dt,
    EndDate:this.dt,
    loading:false,
    list:[],
    employee:[],
    totalLogs:0,
    page:0,
  }

  getLogs = (callback,countOnly,start,max) =>
  {
    ajaxPost({
      url: countOnly ? '/AuditTrailAPI/CountAuditTrails' : '/AuditTrailAPI/ListAuditTrails',
      data: 
      {
        StartDate:this.state.StartDate,
        EndDate:this.state.EndDate,
        EmployeeIDs:this.state.employee.map( x => x.EmployeeID),
      },
      startIndex:start != null ? start : 0,
      maxData: max != null ? max : 0,
      onError: ()=>{},
      onSuccess: data => {
        callback(data);
      },
      finally: ()=>{}
    }
  )

  }

  handleChangePage = (event,page) =>
  {
      this.setState({page});

      const rowsPerPage = 50;

      this.setState({loading:true});

      this.getLogs( data =>
          {
              this.setState({loading:false});
              this.setState({list:data});
  
          }, false,page * rowsPerPage, rowsPerPage);
    }


  handleClick = (evt) =>
  {
    this.setState({loading:true});
    this.getLogs(data =>
    {
        this.setState({totalLogs:data});
        this.handleChangePage(null,0)
    }, true
    )
  }

  onEmployeeSelect = (value) =>
  {
      this.setState({employee:value})
  }

  getEmployees = (input,callback) =>
  {
    fnSearchEmployee(input,data=>
      {
        callback(null,
          {
            options: data,
            complete:true
          })
      });
  }

  onExport = () =>
  {
    var employees = "";
    this.state.employee.forEach( emp => 
    {
      employees += emp.EmployeeID.toString() + ",";
    });
    window.location = window.apihost + "/AuditTrailAPI/ExportToExcel?" +
    "startDate=" + this.state.StartDate + "&" +
    "endDate=" + this.state.EndDate + "&" +
    "devices=&" +
    "employees="+employees;
  }

  render() {
    const { classes } = this.props;
    return (
          <div className={classes.main}>
            <Portal container={this.props.toolbar}>
            <Portal container={global.lblHeader}>
            <Typography variant="title" color="inherit" className={classes.title}>
            <span>
            Audit Trail
            </span>
           </Typography>
           
            <div className={classes.container}>
              <FormLabel component="selectEmpID" className={classes.selectLabel}>Employee Filter</FormLabel>
              <Select.Async
                  id="selectEmpID"
                  value={this.state.employee} 
                  onChange={this.onEmployeeSelect.bind(this)} 
                  loadOptions={this.getEmployees.bind(this)} 
                  isLoading={true}
                  labelKey="FullName"
                  valueKey="FullName"
                  multi={true}
                  className={classes.select}
             />
         
            </div>
          <div className={classes.container}>
          <TextField className={classes.textField}
              value={this.state.StartDate}
              label="Start Date"
              type="date"
              onChange={(evt)=>this.setState({StartDate:evt.target.value})} />
          <TextField className={classes.textField}
              value={this.state.EndDate}
              type="date"
              label="End Date"
              onChange={(evt)=>this.setState({EndDate:evt.target.value})} />
                <div className={classes.wrapper}>
                  <Button raised disabled={this.state.loading} className={classes.button} onClick={this.handleClick.bind(this)}>View</Button>
                  {this.state.loading && <CircularProgress size={30} className={classes.fabProgress} />}
                </div>
                </div>
                <Tooltip id="tooltip-xls"  title="Export to Excel">
            <IconButton disabled={this.state.list.length==0} color="inherit" className={classes.button} onClick={this.onExport.bind(this)}>
                <SaveIcon />
            </IconButton>
            </Tooltip>
            
            </Portal>
        
        </Portal>
        <Paper  style={{ "background": "rgba(255,255,255,0.5)" }} >
        <Table className={classes.table}>
        <Portal container={global.tblHeader}>
        <TableHead>
          <TableRow>
            <TableCell style={{ "minWidth":"100px","maxWidth":"100px"}}>Date/Time</TableCell>
            <TableCell style={{ "minWidth":"100px","maxWidth": "100px"}}>Username</TableCell>
            <TableCell style={{ "minWidth":"100px","maxWidth": "100px"}}>Module</TableCell>
            <TableCell style={{ "minWidth":"150px","maxWidth": "150px"}}>Action</TableCell>
            <TableCell style={{ "minWidth":"300px","maxWidth":"300px"}}>Description</TableCell>
            <TableCell style={{ "minWidth":"80px","maxWidth":"80px"}}>IPAddress</TableCell>
            <Table>&nbsp;</Table>
          </TableRow>
        </TableHead>
        </Portal>
        <TableBody className={classes.tableContent}>
         {this.state.list.map(n => {
            return (
              <TableRow>
                <TableCell style={{ "minWidth":"100px","maxWidth":"100px"}}>{moment(n.Timestamp).format('MM/DD/YYYY HH:ss')}</TableCell>
                <TableCell style={{ "minWidth":"100px","maxWidth":"100px"}}>{n.Username}</TableCell>
                <TableCell style={{ "minWidth":"100px","maxWidth":"100px"}}>{n.Module}</TableCell>
                <TableCell style={{ "minWidth":"150px","maxWidth":"150px"}}>{n.Action}</TableCell>
                <TableCell style={{ "minWidth":"300px","maxWidth":"300px"}}>{n.Description}</TableCell>
                <TableCell style={{ "minWidth":"80px","maxWidth":"80px"}}>{n.IPAddress}</TableCell>
                <Table>&nbsp;</Table>
              </TableRow>
            );
          })}
        </TableBody>
        <TableFooter>
                <TableRow>
                    <TablePagination
                        colSpan={6}
                        count={this.state.totalLogs}
                        rowsPerPage={50}
                        rowsPerPageOptions={[50]}
                        page={this.state.page}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'Next Page',
                        }}
                        onChangePage={this.handleChangePage}
                    />
                </TableRow>
            </TableFooter>
      </Table>
      </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(AuditTrail);



// WEBPACK FOOTER //
// ./src/admin/AuditTrail.js